import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { MembershipTypes } from './MembershipTypes';
import { ApplicationProcess } from './ApplicationProcess';
import { OrientationCallout } from './OrientationCallout';
import { RenewalAndProfile } from './RenewalAndProfile';
import { ImportantNotice } from './ImportantNotice';
import { ApplyCTA } from './ApplyCTA';
export function MembershipPage() {
  return <PageLayout data-id="element-2155">
      <HeaderBanner data-id="element-2156" />
      <MembershipTypes data-id="element-2157" />
      <ApplicationProcess data-id="element-2158" />
      <OrientationCallout data-id="element-2159" />
      <RenewalAndProfile data-id="element-2160" />
      <ImportantNotice data-id="element-2161" />
      <ApplyCTA data-id="element-2162" />
    </PageLayout>;
}